/* eslint-disable */
import { IState } from "@/interfaces/IState";
import axios from "axios";

export const activity = {
  state: {
    currentActivity: {},
    activities: [],
    info: [],
    activitiesTypes: [],
    resource: {}
  },
  mutations: {
    SET_CURRENT_ACTIVITY(state: any, payload: any) {
      state.currentActivity = payload;
    },
    RESET_CURRENT_ACTIVITY(state: any) {
      state.currentActivity = {};
    },
    SET_ACTIVITIES(state: IState, payload: any) {
      state.activities = payload;
    },
    SET_INFO_ACTIVITIES(state: IState, payload: any) {
      state.info = payload;
    },
    ADD_ACTIVITIES(state: IState, payload: any) {
      state.activities.unshift(payload);
    },
    SET_ACTIVITIES_TYPES(state: IState, payload: any) {
      state.activitiesTypes = payload;
    },
    SET_RESOURCE(state: IState, payload: any) {
      state.resource = payload;
    },
  },
  actions: {
    // PETICIONES A LA API
    async getActivitiesByLessonId(context: any, payload: any) {
      await axios
        .get(
          `${axios.defaults.baseURL}activity/student/{lessonId}?lessonId=${payload}`
        )
        .then((res: any) => {
          console.info("Cargando Las actividades por LessonId", res.data);
          context.commit("SET_ACTIVITIES", res.data);
        })
        .catch((error: any) => {
          console.info(
            "Error al cargar las actividades por LessonId",
            payload,
            error
          );
        });
    },
    async getResourceById(context: any, payload: any) {
      await axios
        .get(
          `${axios.defaults.baseURL}activityResource/{activityLessonId}?activityLessonId=${payload}`
        )
        .then((res: any) => {
          console.info("Ejecutado getResourceById", res.data);
          context.commit("SET_RESOURCE", res.data);
        })
        .catch((error: any) => {
          console.info(
            "Error en getResourceById",
            payload,
            error
          );
        });
    },
    async getInfoByLessonId(context: any, payload: any) {
      await axios
        .get(`${axios.defaults.baseURL}information/createActivity/${payload}`)
        .then((res: any) => {
          console.info("obteniendo la informacion por LessonId", res.data);
          context.commit("SET_INFO_ACTIVITIES", res.data);
        })
        .catch((error: any) => {
          console.info("Error al cargar la informacion por LessonId", error);
        });
    },
    async actionGetActivitiesTypes(context: any) {
      await axios
        .get(`${axios.defaults.baseURL}activityType`)
        .then((res: any) => {
          console.info("obteniendo los tipos de actividades", res.data);
          context.commit("SET_ACTIVITIES_TYPES", res.data);
        })
        .catch((error: any) => {
          console.info("Error los tipos de actividades", error);
        });
    },
    async getActivityById(context: any) {
      console.info("do u call?");
    },

    // METODOS
    actionSetCurrentActivity(context: any, payload: any) {
      context.commit("SET_CURRENT_ACTIVITY",payload);
    },
    actionResetCurrentActivity(context: any) {
      context.commit("RESET_CURRENT_ACTIVITY");
    },
    setActivities(context: any, payload: any) {
      console.log("Seteando actividades:",payload)
      context.commit("SET_ACTIVITIES", payload);
    }
  },
  getters: {
    getCurrentActivity(state: any) {
      return state.currentActivity;
    },
    getActivities(state: IState) {
      return state.activities;
    },
    getActivitiesInfo(state: IState) {
      return state.info;
    },
    getActivitiesTypes(state: IState) {
      return state.activitiesTypes;
    },
    getResource(state: IState) {
      return state.resource;
    },
  },
};
